import md5 from 'js-md5';
import axios from "axios";

// 获取域名
export function getDomain() {
    // let domain = window.location.hostname.split(".")[0]
    let domain = 'weilai'
    return domain
}

//文件上传到又拍云
export function uploadCloud(res) {
    let policy = window.btoa(JSON.stringify({
        'bucket': 'cert-images',
        'save-key': '/manage/uploads/{year}{mon}{day}/{random32}{.suffix}',//文件路径
        'expiration': Math.floor(new Date().getTime() / 1000) + 86400,//过期时间
        'notify-url': getDomain() + 'api/enclosure/notify',
        'ext-param': encodeURI(Math.random + "," + getDomain() + "," + 2)
    }))
    let signature = md5(policy + '&M+FeETgJKu60n74cmrX2SzwDNJU=').toString() //此处文件密钥前要添加&符号，容易出错
    var formdata = new FormData();
    formdata.append("file", res.file);
    formdata.append("policy", policy);
    formdata.append("signature", signature);
    const config = Object.assign({}, res.moh || {}, {
        withCredentials: false
    });
    return new Promise((resolve, reject) => {
        axios
            .post(res.action, formdata, config)
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            });
    })
}

//文件上传到又拍云(缩略图)
export function uploadCloudMin(res) {
    let policy = window.btoa(JSON.stringify({
        'bucket': 'cert-images',
        'save-key': '/manage/uploads/{year}{mon}{day}/{random32}{.suffix}',//文件路径
        'expiration': Math.floor(new Date().getTime() / 1000) + 86400,//过期时间
        'notify-url': getDomain() + 'api/enclosure/notify',
        'ext-param': encodeURI(Math.random + "," + getDomain() + "," + 2),
        'x-gmkerl-thumb': '/fw/300'
    }))
    let signature = md5(policy + '&M+FeETgJKu60n74cmrX2SzwDNJU=').toString() //此处文件密钥前要添加&符号，容易出错
    var formdata = new FormData();
    formdata.append("file", res.file);
    formdata.append("policy", policy);
    formdata.append("signature", signature);
    const config = Object.assign({}, res.moh || {}, {
        withCredentials: false
    });
    return new Promise((resolve, reject) => {
        axios
            .post(res.action, formdata, config)
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            });
    })
}



// WEBPACK FOOTER //
// ./src/utils/upyun.js